var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { StorageService } from "~/utils/storage.service";
import md5 from "md5";
var collectionManageModule = namespace("collection-manage");
var CallConfirm = /** @class */ (function (_super) {
    __extends(CallConfirm, _super);
    function CallConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flg = false;
        _this.loading = {
            state: false,
        };
        return _this;
    }
    CallConfirm.prototype.cancel = function () {
        this.$emit("close");
    };
    CallConfirm.prototype.confrim = function () {
        var _this = this;
        var that = this;
        console.log(12);
        this.seatLocalStorage = StorageService.getItem("userInfoStage");
        var ts = String(Date.now());
        var customer = 'C284';
        console.log(customer);
        var signStr = md5(customer + "@" + ts + "@5271@F3F60809078BCB9BFA66B03BF5912010");
        console.log(ts);
        console.log(signStr);
        var myObj = {
            "authentication": {
                "customer": customer,
                "timestamp": ts,
                "seq": "5271",
                "digest": signStr,
            },
            "request": {
                "seq": "5271",
                "userData": "ASD123",
                "caller": "",
                "callee": that.rowData.phoneNo,
                "agent": StorageService.getItem("userInfoStage").agent,
                "noUseBlApi": "0",
                "lineMode": "0",
            },
        };
        fetch("https://tj.msfzmss.com/assetsManager/hjxt/callNumber", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(myObj),
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            if (data.data.result.error === 0) {
                _this.$message({ message: "呼叫成功，请接听软电话！", type: "success" });
                _this.$emit("close");
            }
            else {
                _this.$message({ message: "呼叫失败：" + data.data.result.msg, type: "warning" });
            }
        })
            .catch(function (error) {
            console.error("请求失败:", error);
        });
        var myJSON = JSON.stringify(myObj);
        // var httpRequest = new XMLHttpRequest();//第一步：建立所需的对象
        // httpRequest.open("POST", "https://ft.liansdk.com/assetsManager/hjxt/callNumber", true);
        // httpRequest.setRequestHeader("Content-type", "application/json");
        // httpRequest.send(myJSON);
        //
        // httpRequest.onreadystatechange = function() {
        //   if (httpRequest.readyState == 4 && httpRequest.status == 200) {
        //     var json2 = httpRequest.responseText;//获取到json字符串，还需解析
        //     console.log(json2);
        //     if (JSON.parse(json2).data.result.error == 0) {
        //       that.$message({
        //         message: "呼叫成功，请接听软电话！",
        //         type: "success",
        //       });
        //       that.$emit("close");
        //     } else {
        //       that.$message({
        //         message: "呼叫失败：" + JSON.parse(json2).data.result.msg,
        //         type: "warning",
        //       });
        //     }
        //   }
        // };
        // that.flg = false;
        // return;
    };
    __decorate([
        Prop()
    ], CallConfirm.prototype, "rowData", void 0);
    CallConfirm = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DataGrid: DataGrid,
                DataGridItem: DataGridItem,
            },
        })
    ], CallConfirm);
    return CallConfirm;
}(Vue));
export default CallConfirm;
